import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Header from '../Header';
import Sidebar from '../Sidebar';
import theme from './theme';

const {
  colors: { background, contentBackgroundColor },
} = theme;

const Layout = ({ children }) => {
  const { classes, css } = useStyles(styles);

  return (
    <div className={classes.home}>
      <Sidebar />
      <div className={classes.main}>
        <div className={css({
          zIndex: 1000, boxShadow: 'rgba(193, 217, 255, 0.4) 0px 3px 15px'
        })}>
          <Header title={<FormattedMessage id="title" />} />
        </div>
        <div className={classes.wrapper}>
          <div className={classes.content}>{children}</div>
        </div>
      </div>
    </div>
  );
};

const styles = () => ({
  home: {
    display: 'flex',
    alignItems: 'stretch',
    height: '100%',
    background,
  },
  main: {
    display: 'flex',
    flexDirection: 'column',
    flex: '1 1 auto',
    // boxShadow: '0px 3px 15px rgba(193, 217, 255, 0.4)',
  },
  wrapper: {
    overflow: 'auto',
    background: contentBackgroundColor,
    height: '100%',
    '@media (max-width: 768px)': { overflowX: 'hidden' }
  },
  content: {
    flex: '1 1 auto',
  },
});

Layout.propTypes = {
  children: PropTypes.node,
};

export default Layout;
